import React, { useEffect, useState } from "react"
import "./ViewUniversity.scss"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import { Avatar } from "primereact/avatar"
import { formatDistanceToNow } from "date-fns"
import { Galleria } from "primereact/galleria"

const ViewUniversity = () => {
  document.title = "View University"
  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation()
  const { universityCode } = useParams()
  const [universityData, setUniversityData] = useState({})

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "University", link: "#" },
    { label: "University Details", link: "#" },
  ]

  const getUniversityById = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }

    UniversityApi.getUniversityById(universityCode, config)
      .then(res => {
        setUniversityData(res.data.university)
      })
      .catch(err => {})
  }

  useEffect(() => {
    if (universityCode) {
      getUniversityById()
    }
  }, [universityCode])

  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 5,
    },
    {
      breakpoint: "768px",
      numVisible: 3,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
    },
  ]

  const itemTemplate = item => {
    return (
      <div className="gallery-item-container">
        <img
          src={item.url}
          alt={item.alt}
          style={{
            width: "100%",
            height: "400px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      </div>
    )
  }

  const thumbnailTemplate = item => {
    return (
      <div className="gallery-thumbnail">
        <img
          src={item.url}
          alt={item.alt}
          style={{
            width: "100px",
            height: "67px",
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />
      </div>
    )
  }

  return (
    <div className="view-university">
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="University Details"
            />
          </div>

          <Card className="mt-4">
            <CardBody>
              <Row className="mb-5">
                <Col xs="12">
                  <div
                    className="banner-img"
                    style={{
                      width: "100%",
                      position: "relative",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "300px",
                        overflow: "hidden",
                        borderRadius: "8px",
                        position: "relative",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      <img
                        className="banner-img-img"
                        src={universityData?.bannerImage?.url}
                        alt={universityData?.bannerImage?.alt}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />

                      <div
                        className="university-logo-container"
                        style={{
                          position: "absolute",
                          top: "60%",
                          left: "40px",
                          transform: "translateY(-50%)",
                          width: "150px",
                          height: "150px",
                          backgroundColor: "white",
                          borderRadius: "50%",
                          padding: "2px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: "1",
                          border: "2px solid white",
                        }}
                      >
                        {universityData.logo ? (
                          <img
                            src={universityData?.logo?.url}
                            alt={universityData?.logo?.alt}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: "50%",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "50%",
                              backgroundColor: "#f8f8f8",
                              color: "#888",
                              fontSize: "16px",
                              textAlign: "center",
                              padding: "5px",
                            }}
                          >
                            No Logo Available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  md="9"
                  className="d-flex justify-content-start align-items-start"
                >
                  <div
                    className="university-basic-info"
                    style={{
                      width: "100%",
                      textAlign: "left",
                      paddingTop: "20px",
                    }}
                  >
                    <h4
                      className="mb-4"
                      style={{
                        fontSize: "24px",
                        fontWeight: "600",
                      }}
                    >
                      {universityData.universityName}
                    </h4>

                    <div
                      className="mb-4 d-flex flex-wrap"
                      style={{ gap: "20px" }}
                    >
                      <div className="info-item">
                        <strong className="text-muted">Type:</strong>
                        <span style={{ marginLeft: "8px" }}>
                          {universityData.type &&
                            universityData.type.charAt(0).toUpperCase() +
                              universityData.type.slice(1)}
                        </span>
                      </div>
                      <div className="info-item">
                        <strong className="text-muted">Established:</strong>
                        <span style={{ marginLeft: "8px" }}>
                          {universityData.yearEstablished}
                        </span>
                      </div>
                      <div className="info-item">
                        <strong className="text-muted">Country:</strong>
                        <span style={{ marginLeft: "8px" }}>
                          {universityData.country}
                        </span>
                      </div>
                      <div className="info-item">
                        <strong className="text-muted">UGC Approval:</strong>
                        <span style={{ marginLeft: "8px" }}>
                          {universityData.ugcApproval ? "Yes" : "No"}
                        </span>
                      </div>
                      <div className="info-item">
                        <strong className="text-muted">Status:</strong>
                        <span
                          className={`status ${universityData.verifiedStatus}`}
                          style={{ marginLeft: "8px" }}
                        >
                          {universityData.verifiedStatus === "approve"
                            ? "Approved"
                            : universityData.verifiedStatus === "reject"
                              ? "Rejected"
                              : "Pending"}
                        </span>
                      </div>
                    </div>

                    {universityData.officialWebsite && (
                      <div className="website-info">
                        <strong className="text-muted">Website:</strong>
                        <a
                          href={
                            universityData.officialWebsite.startsWith("http")
                              ? universityData.officialWebsite
                              : `https://${universityData.officialWebsite}`
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            marginLeft: "8px",
                            color: "#0066cc",
                            textDecoration: "none",
                          }}
                        >
                          {universityData.officialWebsite}
                        </a>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>

              <h5 className="border-bottom pb-2 mb-3">Detailed Information</h5>

              <div className="university-view-form">
                <div className="university-view-inp">
                  <label htmlFor="displayName" className="label">
                    Display Name
                  </label>
                  <InputText
                    id="displayName"
                    value={universityData.displayName}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="type" className="label">
                    Type
                  </label>

                  <InputText
                    id="type"
                    value={universityData.type}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="yearEstablished" className="label">
                    Year Established
                  </label>
                  <InputText
                    id="yearEstablished"
                    value={universityData.yearEstablished}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="country" className="label">
                    Country
                  </label>
                  <InputText
                    id="country"
                    value={universityData.country}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="state" className="label">
                    State
                  </label>

                  <InputText
                    id="state"
                    value={universityData.state}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="username" className="label">
                    City
                  </label>
                  <InputText
                    id="city"
                    value={universityData.city}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="pinCode" className="label">
                    Pin Code
                  </label>
                  <InputText
                    id="pinCode"
                    value={universityData.pinCode}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="address" className="label">
                    Address
                  </label>
                  <InputText
                    id="address"
                    value={universityData.address}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="email" className="label">
                    Email
                  </label>
                  <InputText
                    id="email"
                    value={universityData.email}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="officialWebsite" className="label">
                    Official Website
                  </label>
                  <InputText
                    id="officialWebsite"
                    value={universityData.officialWebsite}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="campusSize" className="label">
                    Campus Size
                  </label>
                  <InputText
                    id="campusSize"
                    value={universityData.campusSize}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <InputText
                    id="noOfStudents"
                    value={universityData.noOfStudents}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <InputText
                    id="noOfDepartments"
                    value={universityData.noOfDepartments}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <InputText
                    id="noOfCourses"
                    value={universityData.noOfCourses}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <InputText
                    id="totalFaculty"
                    value={universityData.totalFaculty}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <InputText
                    id="nirfRanking"
                    value={universityData.nirfRanking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <InputText
                    id="indiaToday2023Ranking"
                    value={universityData.indiaToday2023Ranking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <InputText
                    id="timesRanking2024"
                    value={universityData.timesRanking2024}
                    className="inp-field-box"
                    disabled
                  />
                </div>

                <div className="university-view-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <InputText
                    id="ugcApproval"
                    value={universityData.ugcApproval ? "Yes" : "No"}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <InputText
                    id="aiuAffiliation"
                    value={universityData.aiuAffiliation ? "Yes" : "No"}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                  </label>
                  <InputText
                    id="highlights"
                    value={universityData.highlights}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="aboutContent" className="label">
                    AboutContent
                  </label>
                  <InputText
                    id="aboutContent"
                    value={universityData.aboutContent}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="verifiedStatus" className="label">
                    Verified Status
                  </label>
                  <InputText
                    id="verifiedStatus"
                    value={
                      universityData.verifiedStatus === "approve" ? "Yes" : "No"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="verifiedReason" className="label">
                    Verified Reason
                  </label>
                  <InputText
                    id="verifiedReason"
                    value={
                      universityData.verifiedReason
                        ? universityData.verifiedReason
                        : "-"
                    }
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="qsRanking" className="label">
                    QS Ranking
                  </label>
                  <InputText
                    id="qsRanking"
                    value={universityData.qsRanking}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="beddedHospital" className="label">
                    Bedded Hospital
                  </label>
                  <InputText
                    id="beddedHospital"
                    value={universityData.beddedHospital}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                <div className="university-view-inp">
                  <label htmlFor="yearlyIntake" className="label">
                    Yearly Intake
                  </label>
                  <InputText
                    id="yearlyIntake"
                    value={universityData.yearlyIntake}
                    className="inp-field-box"
                    disabled
                  />
                </div>
                {/* <div className="university-view-inp">
                  <label htmlFor="departments" className="label">
                    Departments
                  </label>
                  <InputText
                        id="departments"
                    value={universityData.departments}
                    className="inp-field-box"
                    disabled
                  />
                </div> */}
              </div>

              {/* <div className="cutoffs-section mt-5">
                <h5 className="border-bottom pb-2 mb-4">Cutoff Details</h5>
                <Row>
                  {universityData.cutoffs &&
                    universityData.cutoffs.map((cutoff, index) => (
                      <Col md="4" className="mb-4" key={cutoff._id}>
                        <Card className="h-100 shadow-sm">
                          <CardBody>
                            <h6 className="mb-3 text-primary">
                              {cutoff.year} - {cutoff.quota}
                            </h6>
                            <div className="cutoff-details">
                              <table className="table table-borderless mb-0">
                                <tbody>
                                  <tr>
                                    <td>
                                      <strong>Round 1:</strong>
                                    </td>
                                    <td>{cutoff.rounds.round1}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Round 2:</strong>
                                    </td>
                                    <td>{cutoff.rounds.round2}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Mop-Up Round:</strong>
                                    </td>
                                    <td>{cutoff.rounds.mopUpRound}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <strong>Stray Vacancy:</strong>
                                    </td>
                                    <td>{cutoff.rounds.strayVacancy}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    ))}
                  {(!universityData.cutoffs ||
                    universityData.cutoffs.length === 0) && (
                    <Col xs="12">
                      <div className="text-center py-4">
                        <p className="text-muted mb-0">
                          No cutoff details available
                        </p>
                      </div>
                    </Col>
                  )}
                </Row>
              </div> */}

              <div className="gallery-section mt-5">
                <h5 className="border-bottom pb-2 mb-4">Gallery</h5>
                <div
                  className="gallery-container"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "20px 0",
                  }}
                >
                  {universityData.gallery &&
                  universityData.gallery.length > 0 ? (
                    <Galleria
                      value={universityData.gallery}
                      responsiveOptions={responsiveOptions}
                      numVisible={5}
                      style={{
                        maxWidth: "850px",
                        width: "100%",
                      }}
                      item={itemTemplate}
                      thumbnail={thumbnailTemplate}
                      circular
                      autoPlay
                      transitionInterval={3000}
                      showThumbnails={true}
                      showIndicators
                      changeItemOnIndicatorHover
                      className="custom-galleria"
                    />
                  ) : (
                    <div className="text-center py-4">
                      <p className="text-muted mb-0">
                        No gallery images available
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="reviews-section mt-5">
                <h5 className="border-bottom pb-2 mb-4">Reviews</h5>

                {universityData.reviews && universityData.reviews.length > 0 ? (
                  <Row className="g-4">
                    {universityData.reviews.map((review, index) => (
                      <Col md="6" lg="4" key={review._id}>
                        <Card className="review-card h-100 p-3">
                          <div className="review-header d-flex align-items-center gap-3 mb-3">
                            <Avatar
                              label={review.name.charAt(0).toUpperCase()}
                              size="large"
                              shape="circle"
                              style={{
                                backgroundColor:
                                  "#" +
                                  Math.floor(Math.random() * 16777215).toString(
                                    16,
                                  ),
                                color: "#ffffff",
                                padding: "10px",
                              }}
                            />
                            <div>
                              <h6 className="mb-1">{review.name}</h6>
                              <small className="text-muted">
                                {formatDistanceToNow(
                                  new Date(review.createdAt),
                                  { addSuffix: true },
                                )}
                              </small>
                            </div>
                          </div>

                          <div className="review-content">
                            <p className="mb-0" style={{ lineHeight: "1.6" }}>
                              {review.review}
                            </p>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="text-center py-5">
                    <p>No reviews available</p>
                  </div>
                )}
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewUniversity
